import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { elapsedTime } from "../../utils.js";

function VariableCard({ variable, appendClass = ' '}) {
    const displayAlias = variable.alias || variable.name;
    const displayName = variable.name;

    const [elapsedTimeString, setElapsedTimeString] = useState(
        elapsedTime(variable.lastActivity)
    );

    const navigate = useNavigate();
    const { deviceId } = useParams();

    const handleCardClick = () => {
        navigate(
            `/device/${deviceId}/variable/${variable._id}`
        );
    };

    const zipText = (text, n) => {
        if (text.length > n ){
            return text.substring(n) + "...";
        }
        return text
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            const newElapsedTimeString = elapsedTime(variable.lastActivity);
            if (
                newElapsedTimeString.includes("minuto") ||
                newElapsedTimeString.includes("segundo")
            ) {
                setElapsedTimeString(newElapsedTimeString);
            }
        }, 60000);

        return () => clearInterval(intervalId);
    }, [variable.lastActivity]);

    return (
        <div
            onClick={handleCardClick}
            key={variable._id}
            className={"text-wrap p-5 flex flex-col text-center items-center justify-center shadow-md  border-y-[0.25px] rounded-lg cursor-pointer " + appendClass}
        >
            <h3 className="text-lg font-medium mb-2 w-full leading-tight break-words whitespace-normal">{displayAlias}</h3>
            <p className="text-gray-600 w-full leading-tight break-words whitespace-normal">{displayName}</p>
            <p className="text-sm text-gray-500 mt-2">Última Actividad:</p>
            <p>Hace {elapsedTimeString}</p>
        </div>
    );
}

export default VariableCard;
